module.exports = "pegasus/assets/square-tumblr.png";